import type { RouteRecordRaw } from 'vue-router'

import { AppRoute } from '@/constants'
import { ProcessRoutes } from '@/modules/process/router'
import { ProcessInstanceRoutes } from '@/modules/process-instance/router'
import { ProcessTaskRoutes } from '@/modules/process-task/router'
import { SettingsRoutes } from '@/modules/settings/router'
import { StatisticRoutes } from '@/modules/statistic/router'

export const privateRoutes: RouteRecordRaw[] = [
  {
    path: AppRoute.Dashboard.path,
    name: AppRoute.Dashboard.name,
    component: () => import('@/modules/dashboard/Dashboard.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/modules/exception/NotFound.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Forbidden',
    component: () => import('@/modules/exception/Forbidden.vue'),
  },
  ...ProcessRoutes,
  ...ProcessInstanceRoutes,
  ...ProcessTaskRoutes,
  ...SettingsRoutes,
  ...StatisticRoutes,
]
